﻿
module.exports = {
    bindings: {
        isLarge: '<',
        sectionNumber: '<'
    },
    controller: scheduleBSectionNotesButtonController,
    templateUrl: 'texts/components/section-notes-button.html'
};

scheduleBSectionNotesButtonController.$inject = [
    'common',
    'pdfViewerModal',
    'scheduleBDataService'
];

function scheduleBSectionNotesButtonController(common, pdfViewerModal, scheduleBDataService) {

    var vm = {
        showAnnotation: showAnnotation
    };

    function showAnnotation() {
        scheduleBDataService.getScheduleBPdfFile('section' + vm.sectionNumber)
            .then(function (fileUrl) {
                pdfViewerModal.show(fileUrl, 'Schedule B - Section ' + common.formatting.numberToRoman(vm.sectionNumber));
            }); 
    }


    return vm;

}